import {makeObservable, observable} from 'mobx'
import BaseModel from './BaseModel'

export default class CompetitionsQuery extends BaseModel{
  constructor(store) {
    super(store);
    makeObservable(this, {
      date_from: observable,
      date_to: observable,
      page_number: observable,
      page_count: observable,
      page_size: observable,
      count: observable,
    })
  }
  date_from = new Date(new Date().getFullYear(), new Date().getMonth(), 1);
  date_to = null;
  page_number = 1;
  page_count = 1;
  page_size = 10;
  count = 0;
}